import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import components
import IconButton from '@embeds/common/Buttons/IconButton';
import { ReactComponent as CloseIcon } from '@assets/images/icons/icon-cross.svg';

// import styles
import './_lightbox.scss';

const Lightbox = ({ isCloseable, handleClose, children, verticalAlign }) => {
  const notOutsideBoundary = e => e.stopPropagation();

  const verticalAlignClass = `et-core-lightbox_content_${ verticalAlign }`;

  return (
    <>
      <div className="et-core-lightbox_overlay" onClick={isCloseable ? handleClose : null}>
        <div className={classNames([ 'et-core-lightbox_content', verticalAlignClass ])} onClick={notOutsideBoundary}>
          {isCloseable && (
            <div className="et-core-lightbox_content_btn">
              <IconButton handleClick={handleClose}>
                <CloseIcon className="et-core-lightbox_content_btn_icon" />
              </IconButton>
            </div>
          )}
          <div>{children}</div>
        </div>
      </div>
    </>
  );
};

Lightbox.propTypes = {
  isCloseable: PropTypes.bool.isRequired,
  handleClose: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  verticalAlign: PropTypes.oneOf([ 'top', 'middle', 'bottom' ])
};

Lightbox.defaultProps = {
  handleClose: () => console.log('default handleClose'),
  verticalAlign: 'middle'
};

export default Lightbox;
